import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ColorCircleModule} from '@shared/color-circle/color-circle.module';
import {DropdownModule} from '@paperlessio/sdk/components/dropdown';
import {
  IconLibraryService,
  IconsModule,
  plRichTextBackground,
  plRichTextBold,
  plRichTextCenter,
  plRichTextClean,
  plRichTextColor,
  plRichTextFont,
  plRichTextIndent,
  plRichTextItalic,
  plRichTextJustify,
  plRichTextLeft,
  plRichTextLink,
  plRichTextOl,
  plRichTextOutdent,
  plRichTextQuote,
  plRichTextRedo,
  plRichTextRight,
  plRichTextStrike,
  plRichTextSubscript,
  plRichTextSuperscript,
  plRichTextUl,
  plRichTextUnderline,
  plRichTextUndo,
  plRichTextVariable
} from '@paperlessio/sdk/icons';
import {RichTextComponent} from './rich-text.component';
import {faEllipsisH} from '@fortawesome/pro-solid-svg-icons/faEllipsisH';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {TranslocoModule} from '@ngneat/transloco';
import {PresetExtractNamePipe} from '@shared/controls/color-input/preset-extract-name.pipe';
import {FormsModule} from '@angular/forms';
import {FilterModule} from '@shared/pipes/filter/filter.module';
import {RichTextToolbarComponent} from './rich-text-toolbar/rich-text-toolbar.component';
import {ColorInputModule} from '@shared/controls/color-input/color-input.module';
import {DesignColorsInserterModule} from '@shared/design/design-colors-inserter/design-colors-inserter.module';
import {RouterLink} from '@angular/router';
import {faGlobe} from '@fortawesome/pro-regular-svg-icons';
import {SearchComponent} from '@paperlessio/sdk/components/search';

@NgModule({
  declarations: [
    RichTextComponent,
    RichTextToolbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FontAwesomeModule,
    DropdownModule,
    IconsModule,
    ColorCircleModule,
    TranslocoModule,
    DesignColorsInserterModule,
    FilterModule,
    ColorInputModule,
    RouterLink,
    SearchComponent
  ],
  providers: [
    PresetExtractNamePipe
  ],
  exports: [
    RichTextComponent,
    RichTextToolbarComponent
  ]
})
export class RichTextModule {
  constructor(
    faLibrary: FaIconLibrary,
    library: IconLibraryService
  ) {
    faLibrary.addIcons(faEllipsisH, faGlobe);

    library.addIcons(
      plRichTextFont,
      plRichTextBold,
      plRichTextItalic,
      plRichTextUnderline,
      plRichTextStrike,
      plRichTextColor,
      plRichTextBackground,
      plRichTextLeft,
      plRichTextCenter,
      plRichTextRight,
      plRichTextJustify,
      plRichTextUl,
      plRichTextOl,
      plRichTextIndent,
      plRichTextOutdent,
      plRichTextLink,
      plRichTextUndo,
      plRichTextRedo,
      plRichTextVariable,
      plRichTextClean,
      plRichTextQuote,
      plRichTextSuperscript,
      plRichTextSubscript
    );
  }
}
